import uuid from '@commons/util/Uuid.js'
import Endpoints from '@commons/communication/endpoints.js'
import AgeVerification from '@commons/util/AgeVerification.vue'

export default{
    mixins:[uuid,Endpoints],
    components:{
        AgeVerification
    },
    computed:{
        token: function () {
            return this.$store.getters.getCurrentToken;
        }
    },
    created: function (){

        this.initStore();
        //mobilnak
        // this.$on('my-page-change-event',function (e) {
        //     console.log('event arrived: '+e.detail);
        // })
        var self = this;

        window.document.changePage = function (page) {
            console.log('go to page: '+page);
            if (page == 'basket'){
                window.location.href = ('http://italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu'))+"/mobile/dashboard/basket"
                // self.$router.push('/dashboard/basket');
            }else if (page == 'orders'){
                window.location.href = ('http://italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu'))+"/mobile/dashboard/orders"
                // self.$router.push('/dashboard/orders');
            }else if (page == 'main'){
                window.location.href = ('http://borakft.'+(window.testEnv?'myitsolver.com':'hu')+'/mobile')
                // self.$router.push('/');
            }else if (page == 'webstore'){
                window.location.href = ('http://italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu')+'/mobile')
                // self.$router.push('/');
            }else if (page == 'profile'){
                window.location.href = ('http://italshop.borakft.'+(window.testEnv?'myitsolver.com':'hu'))+"/mobile/dashboard/profile"
                // self.$router.push('/dashboard/profile');
            }
        }
    },
    mounted:function () {
        if (!localStorage.ageVerified){
            this.$refs.av.show();
        }
    },
    methods: {
        initStore:function () {
            if (this.token == null){
                this.$store.commit('setCurrentToken',this.guid())
            }

            var self = this;
            this.connBasketGet(function (r) {
                self.$store.commit('setBasket',r.data);
            });
            this.connWatchedGet(function (r) {
                self.$store.commit('setWatched',r.data);
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/MainApp.js